<div *ngIf="amenities?.length > 0" class="listing-content-section">
  <h3>Amenities <span class="fine-print trinidad">(Offered on site)</span></h3>
  <div class="listing-icon-grid">
    <div *ngFor="let amenity of amenities; let i = index" class="icon-wrapper">
      <div
        (click)="toggleDescription(i)"
        class="icon-inner-wrapper"
        [ngClass]="{
          'with-dropdown': amenity.description || amenity.options || amenity.type === 'cell'
        }"
      >
        <div class="title-wrapper">
          <div class="icon-bullet">
            <div class="w-embed">
              <curbnturf-site-svgs [type]="amenity.type"> </curbnturf-site-svgs>
            </div>
          </div>
          <div class="rift-soft-copy">{{ name(amenity) }}</div>
        </div>
        <div
          *ngIf="(amenity.description || amenity.options || amenity.type === 'cell') && !openDescriptions[i]"
          class="dropdown-icon"
        >
          <div class="html-embed expanded w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>

        <div *ngIf="openDescriptions[i]" class="dropdown-icon">
          <div class="w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>
      </div>
      <div *ngIf="openDescriptions[i]" class="fine-print offsite">
        <span *ngIf="amenity.options || amenity.type === 'cell'" [innerHtml]="options(amenity) + '<br/>'"> </span>
        {{ amenity.description }}
      </div>
    </div>
  </div>
</div>
